import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Image, Avatar } from "@chakra-ui/react";
import { Progress } from "@chakra-ui/react";
import sideImage from "../assets/images/sideimage.png";
import { useAuth } from "./user/AuthProvider";
import axiosInstance, { updateToken } from "../utils/axio-instance";
import { useTranslation } from "react-i18next";
import NavLinks from "./user/NavLinks";
import HeaderLinks from "./user/HeaderLinks";
import HomeLinks from "./user/HomeLinks";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllRoles } from "../actions/search.actions";

const SideMenu = ({}) => {
  const { t } = useTranslation();
  //const { options: roleOptions } = useEnumOptions('user.roles');
  const [progress, setProgress] = useState(0);

  const { user, setUser, getMMtoken } = useAuth();

  const [userInfo, setUserInfo] = useState(null);
  const [profileInfo, setProfileInfo] = useState(null);
  const [activeHomeIndex, setActiveHomeIndex] = useState(null);
  const [showSignupOptions, setShowSignupOptions] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const roleOptions = useSelector((store) => store.search.roles) || [];
  const roleInfo = localStorage.getItem("roles");
  const isBuyer = roleInfo && roleInfo.includes("buyer");

  useEffect(() => {
    if (roleInfo && roleOptions.length === 0) {
      dispatch(fetchAllRoles());
    }
  }, [dispatch, roleInfo, roleOptions.length]);

  useEffect(() => {
    loadUser();
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          return 100;
        } else {
          return prevProgress + 1;
        }
      });
    }, 50); // Adjust the interval as needed for the desired loading speed

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    loadUser();
  }, [localStorage.getItem("userid")]);

  const handleHomeLinkClick = (index) => {
    setActiveHomeIndex(index);
  };

  const loadUser = () => {
    // console.log("Load user info from local storage");
    const storedUserInfo = localStorage.getItem("userid");
    setUserInfo(storedUserInfo);

    if (storedUserInfo && profileInfo == null) {
      
      updateToken(localStorage.getItem("token"));
      // Make your profile API call here
      axiosInstance
        .get(`/users/${storedUserInfo}/profile/`)
        .then((response) => {
          // Handle profile API response
          const storedProfileInfo = response.data;
          setProfileInfo({ ...storedProfileInfo });
          setUser({
            ...user,
            ...storedProfileInfo,
          });
        })
        .catch((error) => {
          // Handle profile API error
          console.error("Profile API error:", error);
          // Only a definitive auth rejection invalidates the stored session —
          // transient/network errors must not log the user out of the UI.
          const status = error?.response?.status;
          if (status === 401 || status === 403) {
            localStorage.removeItem("userid");
            setUserInfo(null);
          }
        });
    }
  };

  const drawerClose = () => {
    document.getElementById("my-drawer-4").checked = false;
  };
  const drawerOpen = () => {
    document.getElementById("my-drawer-4").checked = true;
  };

  const gotoProfile = () => {
    drawerClose();
    navigate("/profile/edit-profile", { replace: true });
  };

  return (
    <>
      {progress < 100 && (
        <Progress
          colorScheme="black"
          size="xs"
          position="fixed"
          top="0"
          left="0"
          width="100%"
          height="1px"
          zIndex="1000"
          value={progress}
        />
      )}
      {/* <AnnouncementBar message={t('announcement_bar')}/> */}
      <div className="font-linksans sticky top-0 z-50 bg-lightBg bg-[#FAFBFC]">
        <div className="pageview-container mx-auto py-4">
          <div className="flex items-center justify-between">
            <div className="flex gap-8 items-center ">
              <NavLink
                to={"/"}
                className="flex items-center space-x-2"
                onClick={() => window.scrollTo(0, 0)}
              >
                <Image
                  mt={1}
                  width={175}
                  src={"/knockthedoor-logo-1.png"}
                  className="2xl:text-4xl xl:text-4xl lg:text-3xl md:text-3xl text-2xl font-bold"
                  alt="KnockTheDoor"
                />
              </NavLink>
              {/* navlink hover dropdown */}

              <div className="flex items-center gap-4">
                <NavLink to={"/buy/start"}>
                  <button className="text-[#060605] hover:bg-borderColor transition-all duration-300 text-sm md:text-base px-4 py-2 rounded-lg border border-borderColor">
                    {t("Buy")}
                  </button>
                </NavLink>
                <NavLink to={"/sell/start"}>
                  <button className="text-[#060605] hover:bg-borderColor transition-all duration-300 text-sm md:text-base px-4 py-2 rounded-lg border border-borderColor">
                    {t("Sell")}
                  </button>
                </NavLink>
              </div>
            </div>

            <div className="flex items-center gap-2">
              {userInfo ? (
                <>
                  {/* profile */}
                  <div
                    className="flex hidden xl:flex lg:flex gap-2 items-center cursor-pointer"
                    onClick={gotoProfile}
                  >
                    <div className="w-12 h-12 overflow-hidden bg-gray-200 rounded-full">
                      <Avatar
                        className="w-full h-full"
                        name={`${(profileInfo?.first_name || "").charAt(0).toUpperCase()}${(profileInfo?.last_name || "").charAt(0).toUpperCase()}`}
                      />
                    </div>
                    <div className="flex flex-col gap-px">
                      <h4 className="text-lg font-medium text-paragraphColor">
                        {profileInfo?.first_name && profileInfo?.last_name && (
                          <>
                            {profileInfo.first_name.charAt(0).toUpperCase() +
                              profileInfo.first_name
                                .slice(1)
                                .toLowerCase()}{" "}
                            {profileInfo.last_name.charAt(0).toUpperCase() +
                              profileInfo.last_name.slice(1).toLowerCase()}
                          </>
                        )}
                      </h4>
                      <span className="text-sm  text-paragraphColor">
                        {profileInfo?.roles?.map((role) => (
                          <span key={role}>
                            {roleOptions.find((r) => r.role_name === role)?.role_label ||
                              role}
                          </span>
                        ))}
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex flex-wrap gap-4 items-center ml-2">
                    <NavLink to={"/login"}>
                      <button className="hidden md:block text-[#060605] hover:bg-borderColor transition-all duration-300 text-sm lg:text-base px-4 py-2 rounded-lg border border-borderColor">
                        {t("signin")}
                      </button>
                    </NavLink>
                    <button
                      type="button"
                      onClick={() => setShowSignupOptions(true)}
                      className="hidden md:block text-[#060605] hover:bg-borderColor transition-all duration-300 text-sm md:text-base px-4 py-2 rounded-lg border border-borderColor"
                    >
                      {t("signup")}
                    </button>
                  </div>
                </>
              )}

              {/* drawer */}
              <div>
                <div className="drawer drawer-end w-10 sm:w-12 md:w-14 lg:w-16 xl:w-16">
                  <input
                    id="my-drawer-4"
                    type="checkbox"
                    className="drawer-toggle"
                  />
                  <div className="drawer-content border flex items-center rounded-lg px-2 py-2 sm:px-4 sm:py-3">
                    {/* Page content here */}
                    <label
                      htmlFor="my-drawer-4"
                      className="rounded-lg cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        className="w-6 h-6"
                      >
                        <path
                          d="M3 6.5H21"
                          stroke="#111518"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <path
                          d="M6.5 12.5L21 12.5"
                          stroke="#111518"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <path
                          d="M10 18.5L21 18.5"
                          stroke="#111518"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </label>
                  </div>
                  <div className="drawer-side z-50">
                    <label
                      htmlFor="my-drawer-4"
                      aria-label="close sidebar"
                      className="drawer-overlay"
                    ></label>
                    <ul className="menu bg-base-200 text-base-content min-h-full w-80 p-4">
                      {/* Sidebar content here */}
                      <div className="flex flex-col justify-center gap-4">
                        {userInfo ? (
                          <>
                            <div className="items-center flex justify-center space-x-2 cursor-pointer" onClick={gotoProfile}>
                              <Avatar
                                  className="w-full h-full"
                                  name={`${(profileInfo?.first_name || "").charAt(0).toUpperCase()}${(profileInfo?.last_name || "").charAt(0).toUpperCase()}`}
                                />
                              <h4 className="text-lg font-medium text-paragraphColor capitalize">
                                <span>{profileInfo?.first_name +
                                  " " +
                                  profileInfo?.last_name}</span>
                              </h4>
                            </div>
                            <div className="w-full justify-center flex flex-col ">
                              <NavLinks
                                profileInfo={profileInfo}
                                onClose={drawerClose}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <Link
                              to={"/"}
                              className="text-lg md:text-lg text-textColor text-center pb-4 border-b border-gray-300 items-center flex justify-center space-x-2"
                            >
                              <Image
                                pt="1"
                                width="35px"
                                height="35px"
                                src={sideImage}
                                alt="KnockTheDoor"
                              />
                            </Link>
                            <div className="w-full justify-center flex flex-col ">
                              <HomeLinks
                                onClose={drawerClose}
                                onSignupClick={() => setShowSignupOptions(true)}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {userInfo ? (
            <div className="hidden flex xl:flex  2xl:flex w-full pt-4 justify-end">
              <div className="flex gap-4 items-center">
                <HeaderLinks profileInfo={profileInfo} />
              </div>
            </div>
          ) : (
            <>{/*no sub-menu before login */}</>
          )}
        </div>
      </div>

      {/* Sign up choice popup */}
      {showSignupOptions && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
          onClick={() => setShowSignupOptions(false)}
        >
          <div
            className="relative w-full max-w-2xl bg-white rounded-2xl shadow-xl p-8"
            onClick={(e) => e.stopPropagation()}
          >
            {/* close button */}
            <button
              type="button"
              aria-label="Close"
              onClick={() => setShowSignupOptions(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M6 6L18 18M6 18L18 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>

            <h3 className="text-xl md:text-2xl font-semibold text-center text-paragraphColor">
              {t("signup_popup_title")}
            </h3>
            <p className="text-sm text-gray-500 text-center mt-2 mb-8">
              {t("signup_popup_subtitle")}
            </p>

            <div className="flex flex-col md:flex-row gap-6">
              {/* Customer card */}
              <NavLink
                to={"/signup/"}
                onClick={() => setShowSignupOptions(false)}
                className="flex-1 group border border-borderColor rounded-xl p-6 text-center hover:border-textColor hover:shadow-md transition-all duration-300"
              >
                <h4 className="text-lg font-semibold text-paragraphColor">
                  {t("signup.title")}
                </h4>
                <p className="text-sm text-gray-500 mt-2 mb-6">
                  {t("signup.sub.title")}
                </p>
                <span className="inline-block text-sm font-medium px-5 py-2 rounded-lg border border-borderColor group-hover:bg-borderColor transition-all duration-300">
                  {t("signup_customer_btn")}
                </span>
              </NavLink>

              {/* Pro / Realtor card */}
              <NavLink
                to={"/pro-signup/"}
                onClick={() => setShowSignupOptions(false)}
                className="flex-1 group border border-borderColor rounded-xl p-6 text-center hover:border-textColor hover:shadow-md transition-all duration-300"
              >
                <h4 className="text-lg font-semibold text-paragraphColor">
                  {t("agent.signup.title")}
                </h4>
                <p className="text-sm text-gray-500 mt-2 mb-6">
                  {t("agent.signup.sub.title")}
                </p>
                <span className="inline-block text-sm font-medium px-5 py-2 rounded-lg border border-borderColor group-hover:bg-borderColor transition-all duration-300">
                  {t("signup_pro_link")}
                </span>
              </NavLink>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(SideMenu);
